import { connect } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { withSnackbar } from 'notistack';
import { withTranslation } from 'react-i18next';
import { notificationsSelector } from '../selectors/appSelectors';
import { removeSnackbar } from '../actions/appActions';
import Notifier from '../components/Notifier/Notifier';

const mapStateToProps = createStructuredSelector({ notifications: notificationsSelector });
const mapDispatchToProps = { removeSnackbar };

export default withTranslation(['common', 'validations'])(
    connect(mapStateToProps, mapDispatchToProps)(
        withSnackbar(Notifier)
    )
);
